import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import calmiRingHand from "@/assets/calmi-ring-hand.png";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut" as const,
    },
  },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

const imageReveal = {
  hidden: { scale: 1.1, opacity: 0, x: 50 },
  visible: {
    scale: 1,
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut" as const,
    },
  },
};

export const CTASection = () => {
  return (
    <section className="section-padding bg-primary text-primary-foreground overflow-hidden">
      <div className="container-calim">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Content */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="text-center lg:text-left"
          >
            <motion.p
              variants={fadeInUp}
              className="text-sm uppercase tracking-[0.2em] opacity-70 mb-3 md:mb-4"
            >
              -25% off with code NY25
            </motion.p>
            <motion.h2
              variants={fadeInUp}
              className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light mb-4 md:mb-6"
            >
              Start Your Wellness Ritual Today
            </motion.h2>
            <motion.p
              variants={fadeInUp}
              className="text-base md:text-lg opacity-80 mb-6 md:mb-8 max-w-lg mx-auto lg:mx-0"
            >
              Join over 25,000 people who chose our copper accessories 
              for their daily balance and well-being.
            </motion.p>
            <motion.div
              variants={fadeInUp}
              className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center lg:justify-start"
            >
              <Link
                to="/collections"
                className="bg-primary-foreground text-primary px-6 md:px-8 py-3 md:py-4 text-sm uppercase tracking-[0.2em] font-medium transition-all duration-300 hover:opacity-90 text-center"
              >
                Discover Our Products
              </Link>
              <Link
                to="/about"
                className="border border-primary-foreground/50 text-primary-foreground px-6 md:px-8 py-3 md:py-4 text-sm uppercase tracking-[0.2em] font-medium transition-all duration-300 hover:bg-primary-foreground/10 text-center"
              >
                Our Story
              </Link>
            </motion.div>
          </motion.div>

          {/* Image - lazy loaded as it's below the fold */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={imageReveal}
            className="relative"
          >
            <img
              src={calmiRingHand}
              alt="Calmi Ring™ - Magnetic copper ring"
              width={600}
              height={600}
              loading="lazy"
              decoding="async"
              className="w-full aspect-square object-cover bg-background"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
